import { DAY_KEY_TO_NUMBER, DEFAULT_SELECTED_DAYS, DAY_NAME_TO_KEY } from './recurrenceConstants'

/**
 * Convert daysStructure object to array of day-of-week numbers
 * @param {Object} daysStructure - Object with day keys and day info objects containing isSelected property
 * @returns {number[]} Array of day-of-week numbers (0-6, where 0 is Sunday)
 */
export const getActiveDaysArray = daysStructure => {
  if (!daysStructure) return []

  return Object.entries(daysStructure)
    .filter(([_, dayInfo]) => dayInfo?.isSelected)
    .map(([dayKey]) => DAY_KEY_TO_NUMBER[dayKey])
    .filter(dayNum => dayNum !== undefined)
}

/**
 * Convert selector days array into a unified structure containing all day information
 * @param {Array} days - Array of day objects with 'day', 'isSelected', 'customerRequired'/'isRequired' properties
 * @returns {Object} Object with day keys and complete day information objects
 */
export const mapDaysToDialogStructure = days => {
  const result = {}

  if (!Array.isArray(days)) return result

  // Initialize all days with default values
  Object.entries(DAY_NAME_TO_KEY).forEach(([dayName, dayKey]) => {
    result[dayKey] = {
      day: dayName,
      isSelected: false,
      customerRequired: false,
      isRequired: false,
    }
  })

  // Update with actual data from the selector
  days.forEach(d => {
    const dayKey = DAY_NAME_TO_KEY[d.day]
    if (dayKey) {
      result[dayKey] = {
        day: d.day,
        isSelected: d.isSelected || false,
        customerRequired: d.customerRequired || false,
        isRequired: d.isRequired || d.customerRequired || false,
      }
    }
  })

  return result
}

/**
 * Convert unified days structure to daysOfWeek form structure
 * @param {Object} daysStructure - Object with day keys and complete day information
 * @returns {Object} daysOfWeek object for form
 */
export const convertUnifiedDaysToForm = (daysStructure = {}) => {
  const daysOfWeek = {}
  Object.keys(DEFAULT_SELECTED_DAYS).forEach(dayKey => {
    const dayInfo = daysStructure[dayKey]
    daysOfWeek[dayKey] = {
      isSelected: dayInfo?.isSelected || false,
      isRequired: dayInfo?.isRequired || dayInfo?.customerRequired || false,
    }
  })
  return daysOfWeek
}

/**
 * Parse service interval data and extract recurrence parameters
 * @param {string|Object} serviceIntervalData - Service interval string or backend recurrence object
 * @returns {Object} Object with recurrenceInterval and recurrencePer
 */
export const parseServiceIntervalData = serviceIntervalData => {
  if (typeof serviceIntervalData === 'object' && serviceIntervalData !== null) {
    return {
      recurrenceInterval: serviceIntervalData.recurrenceInterval || 'Week',
      recurrencePer: parseInt(serviceIntervalData.recurrencePer, 10) || 1,
    }
  }

  if (typeof serviceIntervalData === 'string' && serviceIntervalData.includes('-')) {
    const [interval, per] = serviceIntervalData.split('-')
    return {
      recurrenceInterval: interval || 'Week',
      recurrencePer: parseInt(per, 10) || 1,
    }
  }

  // Default fallback
  return { recurrenceInterval: 'Week', recurrencePer: 1 }
}
